import { render, staticRenderFns } from "./RolesAddUpdate.vue?vue&type=template&id=6098c396"
import script from "./RolesAddUpdate.vue?vue&type=script&lang=js"
export * from "./RolesAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports